import http from '../../axios-config/g-http-metodos';

function getParametrosComissoes() {
  const { res, erro, requisicao } = http.get(`ParametrosComissao/GetAll`)
  return { ParametrosComissao: res, erro, requisicao }
}


function EditarParametrosComissao(comissaoMinima, comissaoMaxima) {
  const { res, erro, requisicao } = http.post(`ParametrosComissao/EditarParametrosComissao/${comissaoMinima}/${comissaoMaxima}`)
  return { ParametrosComissao: res, erro, requisicao }
}

const ParametrosComissoesController = {
  EditarParametrosComissao,
  getParametrosComissoes
}

export default ParametrosComissoesController
